import { useEffect } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Link } from "react-router-dom";
import { PageWrapper } from "components";
import { SingleCard } from "components/Main";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import { optionsReports } from "constants/index";

import Typography from "@material-ui/core/Typography";
import iconProfile from "assets/images/auth/icons/icon-profile.svg";
import iconSlogan from "assets/images/auth/icons/icon-slogan.svg";

const TypeReport = ({ setLoading }) => {
  const gContext = useGlobalContext();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <PageWrapper
      isBack
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>Denunciar Robo</h1>
            </Row>
          </Col>
        </Row>
      }
    >
      {optionsReports.map(({ to, text, icon }) => {
        if (to === "/") {
          return (
            <Col md={4} className="pt5 pb5">
              <Row center="xs" middle="xs" className="h-100">
                <Col xs={12}>
                  <h2>Se el México que quieres ser.</h2>
                </Col>
              </Row>
            </Col>
          );
        }

        return <SingleCard key={to} to={to} title={text} icon={icon} />;
      })}
    </PageWrapper>
  );
};

export default withLoader(TypeReport, "Cargando información");
